$('.testimonial-slider').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [{
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 749,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }        
    ]
});

$('.addons-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    autoplay: false,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 749,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }       
    ]
});

$('.fb-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [{
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 749,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }        
    ]
});

$('.gallery-reviews-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    variableWidth: true
});

// PDP Popup
$(document).ready(function(){
  function showPopup() {
    $(".product_popup").addClass("is-open");
    $(".prd_popup_overlay").addClass("is-open");    
    $("html").addClass("overflow-hidden");
  }

  function hidePopup() {
    $(".product_popup").removeClass("is-open");
    $(".prd_popup_overlay").removeClass("is-open");    
    $("html").removeClass("overflow-hidden");
  }

  $(".product__info-container .product-form__buttons button[type=submit]").click(function(){
    setTimeout(showPopup, 1000);
  });

  $(document).click(function(event) { 
    if(!$(event.target).closest('.product_popup').length && !$(event.target).is('.product_popup')) {
      hidePopup();
    }        
  });

  $(".popup_close").click(function(){
    hidePopup();
  });

  // Popup Success
  $('.product_popup .product-form__submit').click(function() {
      $(this).closest('.product-form__buttons').find('.popup-success').addClass('is-active');
      $(this).closest('.card-wrapper').find('.card__content').addClass('is-active');
  });
});

// ScrollTo Cart Page
// function submitForm(event) {
//     // Prevent default form submission
//     event.preventDefault();

//     // Submit the form using JavaScript
//     var form = document.getElementById('myForm');
//     var formData = new FormData(form);
//     var xhr = new XMLHttpRequest();
//     xhr.open('POST', form.action, true);
//     xhr.onload = function() {
//         // After form submission is complete, reload the page
//         setTimeout(function() {
//             window.location.reload();
//         }, 100); // Adjust the delay as needed

//         // Scroll to the bottom after the reload
//         window.onload = function() {
//             setTimeout(function() {
//                 window.scrollTo(0, document.body.scrollHeight);
//             }, 500); // Adjust the delay as needed
//         };
//     };
//     xhr.send(formData);
// }

// Sticky ATC Trigger
$('.sticky-atc-button').on('click', function() {
  $(this).find('span').hide();
  $(this).find('.loading__spinner').removeClass('hidden');

  setTimeout(() => {
    $('.product__info-container .product-form__buttons button[type=submit]').click();
    $(this).find('.loading__spinner').addClass('hidden');
    $(this).find('span').show();
  }, 1000);
});

// Announcement bar close
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=/";
}

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

$(document).ready(function () {
  // Check if the cookie is set
  if (getCookie('ro_announcement_closed') === 'true') {
    $('.announcement-bar-section').hide();
  }

  // On close button click
  $('.announcement-bar .icon-close').on('click', function () {
    $('.announcement-bar-section').hide();
    setCookie('ro_announcement_closed', 'true', 1); // Set for 1 day
  });
});

// Cookie Button Trigger
$('body').on('click', '.trigger-btn', function(){
  $(".tinycookie-button:not(.tinycookie-main-buttons .tinycookie-button)").each(function() {      
    $(this).click();
  });
});

// Allow only heart emoji (line-item PDP)
document.getElementById('nev').addEventListener('input', function(e) {
  const emojiRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])|([\u2600-\u27BF\u2B50\u2B55])|([\uD83C][\uDF00-\uDFFF])|([\uD83D][\uDC00-\uDE4F\uDE80-\uDEFF])|([\uD83E][\uDD00-\uDDFF])/g;
    
  const filteredValue = this.value.replace(emojiRegex, (match) => {
    if (match === '❤' || match === '♥' || match === '❤️') {
        return match;
    }
    return '';
  });
    
  if (this.value !== filteredValue) {
      this.value = filteredValue;
  }
});

// Addons Collection
// $(document).on('click', '.product__info-wrapper .product-form__submit', function (e) {
//   e.preventDefault();

//   const $addToCartForm = $(this).closest('form');
//   const selectedAddOns = $addToCartForm.find(".product-checkbox:checked");
//   const mainProductId = $addToCartForm.find("input[name='id']").val();
//   const selectedVariants = [];

//   // Reset visibility of all .added_prd_wrap before processing
//   $(".added_prd_wrap[data-product-id]").addClass("hidden");

//   // Add main product variant
//   selectedVariants.push({
//     id: mainProductId,
//     quantity: 1,
//   });

//   // Process selected add-on variants
//   selectedAddOns.each(function() {
//     const addOnVariantId = $(this).data("product-id");
//     selectedVariants.push({
//       id: addOnVariantId,
//       quantity: 1,
//     });

//     $(".added_prd_wrap[data-product-id='" + addOnVariantId + "']").removeClass("hidden");
//     $(".added_recommend .grid__item[data-product-id='" + addOnVariantId + "']").addClass("hidden");    
//   });

//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: { items: selectedVariants },
//     dataType: "json",
//     success: function () {
//       console.log("Products added to cart");
//     },
//     error: function (xhr, status, error) {
//       console.log("Error adding products to cart:", error);
//     }
//   });

//   return false;
// });